"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("../../constant");
const util_1 = require("../../util");
const wallet_1 = require("../../wallet");
const types_1 = require("@keplr-wallet/types");
const ethers_1 = require("ethers");
const ethermint_1 = require("../../util/ethermint");
const provider_1 = require("../../util/provider");
const error_1 = require("../metamask/error");
const SWTH = {
    coinDenom: "SWTH",
    coinMinimalDenom: "swth",
    coinDecimals: 8,
    coinGeckoId: "switcheo",
    gasPriceStep: constant_1.CARBON_GAS_PRICE,
};
class KeplrAccount {
    static createKeplrSigner(keplr, chainInfo, account) {
        const signDirect = (signerAddress, doc) => __awaiter(this, void 0, void 0, function* () {
            return yield provider_1.signTransactionWrapper(() => __awaiter(this, void 0, void 0, function* () {
                const signOpts = { preferNoSetFee: true };
                return yield keplr.signDirect(chainInfo.chainId, signerAddress, doc, signOpts);
            }));
        });
        const signAmino = (signerAddress, doc) => __awaiter(this, void 0, void 0, function* () {
            return yield provider_1.signTransactionWrapper(() => __awaiter(this, void 0, void 0, function* () {
                const signOpts = { preferNoSetFee: true };
                return yield keplr.signAmino(chainInfo.chainId, signerAddress, doc, signOpts);
            }));
        });
        const getAccounts = () => __awaiter(this, void 0, void 0, function* () {
            return [
                {
                    algo: "secp256k1",
                    address: account.bech32Address,
                    pubkey: account.pubKey,
                },
            ];
        });
        const sendEvmTransaction = (api, req) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            try {
                const request = yield ethermint_1.populateEvmTransactionDetails(api, req);
                const signedTx = yield keplr.signEthereum(
                // carbon chain id
                (_b = (_a = api.wallet) === null || _a === void 0 ? void 0 : _a.getChainId()) !== null && _b !== void 0 ? _b : '', 
                // cosmos address
                (_d = (_c = api.wallet) === null || _c === void 0 ? void 0 : _c.bech32Address) !== null && _d !== void 0 ? _d : '', JSON.stringify(request), types_1.EthSignType.TRANSACTION);
                const rlpEncodedHex = `0x${Buffer.from(signedTx).toString('hex')}`;
                const provider = new ethers_1.ethers.providers.JsonRpcProvider(constant_1.NetworkConfigs[api.network].evmJsonRpcUrl);
                return (yield provider.sendTransaction(rlpEncodedHex)).hash;
            }
            catch (error) {
                console.error(error);
                throw (error_1.parseEvmError(error));
            }
        });
        const signMessage = (address, message) => __awaiter(this, void 0, void 0, function* () {
            const chainId = chainInfo.chainId;
            const { signature } = yield keplr.signArbitrary(chainId, address, message);
            return Buffer.from(signature, 'base64').toString('hex');
        });
        return {
            type: wallet_1.CarbonSignerTypes.BrowserInjected,
            signDirect,
            signAmino,
            getAccounts,
            sendEvmTransaction,
            signMessage,
        };
    }
    static createKeplrSignerAmino(keplr, chainInfo, account) {
        const signAmino = (signerAddress, doc) => __awaiter(this, void 0, void 0, function* () {
            const signOpts = { preferNoSetFee: true };
            return yield keplr.signAmino(chainInfo.chainId, signerAddress, doc, signOpts);
        });
        const getAccounts = () => __awaiter(this, void 0, void 0, function* () {
            return [
                {
                    algo: "secp256k1",
                    address: account.bech32Address,
                    pubkey: account.pubKey,
                },
            ];
        });
        const sendEvmTransaction = (api, req) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            try {
                const request = yield ethermint_1.populateEvmTransactionDetails(api, req);
                const signedTx = yield keplr.signEthereum(
                // carbon chain id
                (_b = (_a = api.wallet) === null || _a === void 0 ? void 0 : _a.getChainId()) !== null && _b !== void 0 ? _b : '', 
                // cosmos address
                (_d = (_c = api.wallet) === null || _c === void 0 ? void 0 : _c.bech32Address) !== null && _d !== void 0 ? _d : '', JSON.stringify(request), types_1.EthSignType.TRANSACTION);
                const rlpEncodedHex = `0x${Buffer.from(signedTx).toString('hex')}`;
                const provider = new ethers_1.ethers.providers.JsonRpcProvider(constant_1.NetworkConfigs[api.network].evmJsonRpcUrl);
                return (yield provider.sendTransaction(rlpEncodedHex)).hash;
            }
            catch (error) {
                console.error(error);
                throw (error_1.parseEvmError(error));
            }
        });
        const signMessage = (address, message) => __awaiter(this, void 0, void 0, function* () {
            const chainId = chainInfo.chainId;
            const { signature } = yield keplr.signArbitrary(chainId, address, message);
            return Buffer.from(signature, 'base64').toString('hex');
        });
        return {
            type: wallet_1.CarbonSignerTypes.BrowserInjected,
            signAmino,
            getAccounts,
            sendEvmTransaction,
            signMessage,
        };
    }
    static queryFeeCurrencies(configProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenClient = configProvider.getTokenClient();
            const coingeckoIdMap = tokenClient.geckoTokenNames;
            // Query minGasPrices from on-chain (for testnet/devnet/localhost)
            const gasPricesResult = yield configProvider.query.fee.MinGasPriceAll({});
            const feeCurrencies = gasPricesResult.minGasPrices.reduce((result, price) => {
                var _a, _b, _c;
                const token = tokenClient.tokenForDenom(price.denom);
                if (!token || token.denom === "swth")
                    return result;
                // Check if gas price is valid, else add default
                const gasPriceAdjusted = util_1.NumberUtils.bnOrZero(price.gasPrice).shiftedBy(-constant_1.decTypeDecimals);
                const minGasPrice = gasPriceAdjusted.isNaN() || gasPriceAdjusted.isZero()
                    ? (_b = (_a = KeplrAccount.BASE_CHAIN_INFO.gasPriceStep) === null || _a === void 0 ? void 0 : _a.low) !== null && _b !== void 0 ? _b : constant_1.CARBON_GAS_PRICE.low
                    : gasPriceAdjusted.toNumber();
                result.push({
                    coinDenom: (_c = token.symbol) !== null && _c !== void 0 ? _c : token.denom,
                    coinMinimalDenom: token.denom,
                    coinDecimals: token.decimals.toNumber(),
                    coinGeckoId: coingeckoIdMap[token.denom],
                    gasPriceStep: {
                        low: minGasPrice,
                        average: minGasPrice,
                        high: minGasPrice,
                    },
                });
                return result;
            }, []);
            return feeCurrencies;
        });
    }
    static processCurrencies(feeCurrencies) {
        return feeCurrencies.reduce((prevCurrencies, feeCurrency) => {
            const currentFeeCurrency = {
                coinDenom: feeCurrency.coinDenom,
                coinMinimalDenom: feeCurrency.coinMinimalDenom,
                coinDecimals: feeCurrency.coinDecimals,
                coinGeckoId: feeCurrency.coinGeckoId,
            };
            prevCurrencies.push(currentFeeCurrency);
            return prevCurrencies;
        }, []);
    }
    static getChainInfo(configProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = configProvider.getConfig();
            const bech32Prefix = config.Bech32Prefix;
            const chainId = config.chainId;
            const url = "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/master/cosmos/carbon.json";
            let keplrChainInfo;
            try {
                keplrChainInfo = yield (yield util_1.FetchUtils.fetch(url)).json();
            }
            catch (error) {
                console.warn(error);
            }
            if (config.network === constant_1.Network.MainNet && keplrChainInfo) {
                if (keplrChainInfo.nodeProvider) {
                    delete keplrChainInfo.nodeProvider;
                }
                return keplrChainInfo;
            }
            const feeCurrencies = yield this.queryFeeCurrencies(configProvider);
            const networkFees = [KeplrAccount.SWTH_CURRENCY, ...feeCurrencies];
            const currencies = this.processCurrencies(networkFees);
            return {
                feeCurrencies: networkFees,
                bip44: KeplrAccount.BASE_CHAIN_INFO.bip44,
                currencies: currencies,
                stakeCurrency: KeplrAccount.SWTH_CURRENCY,
                rest: config.restUrl,
                rpc: config.tmRpcUrl,
                chainName: `Carbon (${config.network})`,
                chainId: chainId,
                bech32Config: {
                    bech32PrefixAccAddr: `${bech32Prefix}`,
                    bech32PrefixAccPub: `${bech32Prefix}pub`,
                    bech32PrefixValAddr: `${bech32Prefix}valoper`,
                    bech32PrefixValPub: `${bech32Prefix}valoperpub`,
                    bech32PrefixConsAddr: `${bech32Prefix}valcons`,
                    bech32PrefixConsPub: `${bech32Prefix}valconspub`,
                },
                features: ["ibc-transfer", "ibc-go"],
            };
        });
    }
    static signPublicKeyMergeAccount(publicKey, address, chainId, keplr) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = `${ethermint_1.PUBLIC_KEY_SIGNING_TEXT}${publicKey}`;
            return KeplrAccount.signArbitrary(address, chainId, message, keplr);
        });
    }
    static signArbitrary(signerAddress, chainId, message, keplr) {
        return __awaiter(this, void 0, void 0, function* () {
            const signature = yield keplr.signArbitrary(chainId, signerAddress, message);
            return Buffer.from(signature.signature, 'base64').toString('hex');
        });
    }
}
KeplrAccount.SWTH_CURRENCY = SWTH;
KeplrAccount.BASE_CHAIN_INFO = {
    bip44: { coinType: util_1.AddressUtils.SWTHAddress.coinType() },
    currencies: [],
    feeCurrencies: [SWTH],
    gasPriceStep: SWTH.gasPriceStep,
};
exports.default = KeplrAccount;
